module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Home-Desktop.aafbc7d3.jpg";